<template>
  <div v-if="uploadingImage" class="content-spinner">
    <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
  </div>
  <div v-else>
    <v-row>
      <div class="text-center" :class="{ 'mr-3': $vuetify.breakpoint.lgAndUp }">
        <croppa
          v-model="myCroppa"
          :width="256"
          :height="256"
          :quality="2"
          :accept="'image/*'"
          :initial-image="item.image ? item.image.contentUrl + '?x-request=html' : null"
          @file-choose="imageChanged = true"
          @image-remove="imageChanged = true"
        >
        </croppa>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation class="flex" @submit.prevent="onSubmit(item)">
        <v-text-field
          v-model="item.name"
          type="text"
          label="name"
          hint="The organization name"
          required
          :rules="nameRules"
          :error-messages="isInvalid('name') ? violations.name : []"
          @input.native="handleUpdateField('name', $event.target.value)"
        ></v-text-field>
      </v-form>
    </v-row>

    <v-dialog v-model="deleteConfirmShow" max-width="400">
      <v-card>
        <v-card-title class="headline">Delete {{ item.name }}?</v-card-title>
        <v-card-text>
          Are you sure you want to delete {{ item.name }}? <br /><br />
          The deleted data <strong>can't be recovered</strong>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="grey darken-1" text @click.native="onDeleteCancel">Cancel</v-btn>
          <v-btn color="red" text @click.native="onDeleteConfirm">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fetch from '@/utils/fetch'

export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    handleDelete: {
      type: Function,
      required: false,
      default: () => {}
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      imageChanged: false,
      uploadingImage: false,
      myCroppa: {},
      deleteConfirmShow: false,
      valid: true,
      nameRules: [v => (!!v && !!v.trim()) || 'name is required']
    }
  },

  computed: {
    // eslint-disable-next-line
      item () {
      return this.initialValues || this.values
    },

    violations() {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid(key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },

    onDeleteConfirm() {
      this.deleteConfirmShow = false
      this.handleDelete()
    },

    onDeleteCancel() {
      this.deleteConfirmShow = false
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.myCroppa.generateBlob(
          blob => {
            if (this.imageChanged) {
              if (blob) {
                let formData = new FormData()
                formData.append('file', blob)

                this.uploadingImage = true

                return fetch('/media_objects', {
                  method: 'POST',
                  body: formData
                })
                  .then(response => {
                    this.uploadingImage = false
                    return response.json()
                  })
                  .then(data => {
                    this.item.image = data
                    this.handleSubmit(this.item)
                  })
                  .catch(e => {
                    // eslint-disable-next-line no-console
                    console.log(e)
                  })
              } else {
                this.item.image = null
                this.handleSubmit(this.item)
              }
            } else {
              this.handleSubmit(this.item)
            }
          },
          null,
          0.8
        )
      }
    }
  }
}
</script>
